<template>
  <svg xmlns="http://www.w3.org/2000/svg" width="25" height="25" fill="none" viewBox="0 0 25 25">
    <path :fill="fill" d="M16.915.998h-9.7c-3.943 0-7.15 3.207-7.15 7.15v9.7c0 3.943 3.207 7.15 7.15 7.15h9.7c3.942 0 7.15-3.207 7.15-7.15v-9.7c0-3.943-3.208-7.15-7.15-7.15zm4.735 16.85c0 2.616-2.12 4.736-4.735 4.736h-9.7c-2.616 0-4.736-2.12-4.736-4.736v-9.7c0-2.615 2.12-4.736 4.735-4.736h9.701c2.615 0 4.735 2.12 4.735 4.736v9.7z"/>
    <path :fill="fill" d="M12.065 6.79c-3.423 0-6.207 2.785-6.207 6.208 0 3.422 2.784 6.207 6.207 6.207s6.207-2.784 6.207-6.207-2.784-6.207-6.207-6.207zm0 10c-2.095 0-3.793-1.697-3.793-3.792 0-2.095 1.698-3.793 3.793-3.793s3.793 1.698 3.793 3.793-1.698 3.793-3.793 3.793z"/>
  </svg>
</template>

<script>
  export default {
    name: "Instagram",
    props: ['fill']
  }
</script>

<style scoped>

</style>